package com.essntl.features.proposal.ui.allproposal.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.esIconPainterResource
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AllProposalEmpty(
    onAddProposal: () -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier,
    ) {
        Image(
            painter = esIconPainterResource(EsIcons.EmptyList),
            contentDescription = null,
            modifier = Modifier
                .padding(
                    vertical = 17.dp,
                    horizontal = 25.dp,
                )
                .width(150.dp)
                .height(166.dp)
        )

        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier
                .width(219.dp)
        ) {
            Text(
                text = "Click on the button to create a new Proposal",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
                textAlign = TextAlign.Center,
            )

            Spacer(modifier = Modifier.height(17.dp))

            EsLargePrimaryButton(
                onClick = onAddProposal,
                text = "Add proposal",
                suffixIconRes = EsIcons.Add,
            )
        }
    }
}